export default "__VITE_ASSET__$KkIq5NO__"